import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Model } from '../../models/model';

const filter = createFilterOptions()

export const AutocompleteListProjects = ({ handleFilters }) => {

    const [projectsList, setProjectsList] = useState([])

    useEffect(() => {
        handleInitGetProjects()
    }, [])

    const handleChange = async (e, newValue) => {
        console.log({ newValue })
        await handleFilters({
            target: {
                name: 'id_ppto',
                value: newValue?.id || null
            }
        })
    }

    const handleInitGetProjects = async () => {
        const resultsTasks = await Model.getAll({ url: 'projects/tasks/projects-list/all' })
        setProjectsList(resultsTasks)
    }

    return (
        <Autocomplete
            onChange={(e, newValue) => handleChange(e, newValue)}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={projectsList}
            getOptionLabel={(option) => {

                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }

                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }

                // Regular option
                return option.nombre;
            }}
            renderOption={(props, option) => <li {...props}>{option.nombre}</li>}
            sx={{ width: '100%' }}
            size='small'
            freeSolo
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Buscar por proyectos"
                    placeholder='Ingrese nombre proyecto'
                />
            )}
        />
    );
}